import { createContext } from "react"
export const UserContext = createContext(null)
export const ComplexesContext = createContext(null)
export const ComplexesFilterContext = createContext(null)
export const CurrentComplexContext = createContext(null)
